// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckoutDelivery_container__3O4qp"};